import { Component } from '@angular/core';

@Component({
  selector: 'app-page-spin',
  templateUrl: './page-spin.component.html',
  styleUrls: ['./page-spin.component.scss'],
})
export class PageSpinComponent {}
